import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {ServerConnectionService} from "../../../services/serverConnection/server-connection.service";
import {appInjector} from "../../appInjector";
import {throttle} from "rxjs/operators";
import {interval} from "rxjs";
import {ActionLogService} from "../../../services/actionLogService/action-log.service";
import {GlobalEventsService} from '../../../services/global-events.service';


export class ServerConnectionPlugin extends AbstractMainPlugin {
  private serverConnectionService : ServerConnectionService;
  private actionLogService : ActionLogService;
  private eventService: GlobalEventsService;

  constructor(item:Item) {
    super(item);
    this.serverConnectionService = appInjector.get(ServerConnectionService);
    this.actionLogService = appInjector.get(ActionLogService);
    this.eventService = appInjector.get(GlobalEventsService);
    this.initListeners();
  }

  private initListeners(){
    this.item.config.subject
      .pipe(throttle(config => interval(1000), {trailing: true}))
      .subscribe((config) => {
        this.serverConnectionService
          .updateObject(config.asSimpleObject())
          .subscribe((object) => {
            this.eventService.UpdatedObjectEvent.emit(config);
          });
      });

    // this.item.getObservable('updateObject').pipe(throttle(config => interval(1000), {trailing: true}))
    //   .subscribe((config) => {
    //     this.serverConnectionService.updateObject(config.asSimpleObject()).subscribe((object)=>{
    //       this.actionLogService.onConfigUpdated
    //     });
    //   });
  }
}
